import { render } from "./Backup.vue?vue&type=template&id=2d9f377b&scoped=true"
import script from "./Backup.vue?vue&type=script&lang=js"
export * from "./Backup.vue?vue&type=script&lang=js"

import "./Backup.vue?vue&type=style&index=0&id=2d9f377b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9f377b"]])

export default __exports__